import { jsx as _jsx } from "react/jsx-runtime";
import { PageTabs } from "./PageTabs.js";
const sections = [
    { id: "payment", label: "Пополнение баланса", href: "/payments" },
    { id: "history", label: "История платежей", href: "/payments/history" },
];
export function PaymentsNavigation({ active }) {
    return (_jsx(PageTabs, { label: "\u0420\u0430\u0437\u0434\u0435\u043B\u044B \u043E\u043F\u043B\u0430\u0442\u044B", tabs: sections, activeHref: sections.find((section) => section.id === active).href }));
}
